<mat-toolbar>

  @if(sortVisible) {
  <button mat-icon-button [matMenuTriggerFor]="sorts" [matMenuTriggerData]="{sorts: filter.sorter.sorts}" matBadge="1"
    [matBadgeHidden]="!isSorted" matBadgeColor="primary" matBadgeSize="small" matBadgePosition="below after">
    <mat-icon>sort</mat-icon>
  </button>
  }

  @if(groupVisible) {
  <button mat-icon-button [matMenuTriggerFor]="groupings" [matMenuTriggerData]="{groupings: filter.grouper.groupings}"
    matBadge="1" [matBadgeHidden]="!isGrouped" matBadgeColor="primary" matBadgeSize="small"
    matBadgePosition="below after">
    <mat-icon>filter_1</mat-icon>
  </button>
  }

  <span class="spacer"></span>

  <button mat-icon-button (click)="onReset()" [disabled]="resetDisabled">
    <mat-icon>refresh</mat-icon>
  </button>
  <button mat-icon-button (click)="onShow()">
    <mat-icon>task_alt</mat-icon>
  </button>

</mat-toolbar>

<div class="selector-state">
  <div class="label-small selection-path">{{selectionPath}}</div>
  @if(sortPath) {
  <div class="label-small selection-path">{{sortPath}}</div>
  }
  @if(groupPath) {
  <div class="label-small selection-path">{{groupPath}}</div>
  }
</div>

<div class="section-host">

  @for(section of sections; track $index) {

  <ui-section-header label="{{section.title}}" [divider]="true" [button]="false"></ui-section-header>

  <mat-chip-listbox [multiple]="true" [selectable]="true" [disabled]="section.selectors.length < 2">

    @for(selector of section.selectors; track selector.id) {

    <mat-chip-option [selected]="selector.state" [disabled]="selector.currentCount < 1"
      (click)="toggleSelected(section, selector)">
      @if(selector.currentCount > 0) {
      <span class="label-small">{{selector.title}} <span class="current-count">{{selector.currentCount}}</span></span>
      }
      @else {
      <span class="label-small">{{selector.title}}</span>
      }
    </mat-chip-option>

    }

  </mat-chip-listbox>

  }

</div>

<mat-menu #sorts="matMenu">

  <ng-template matMenuContent let-sorts="sorts">

    <button mat-menu-item [disabled]="true">
      <span>{{text.sortTitle}}:</span>
    </button>

    <mat-divider></mat-divider>

    <button mat-menu-item [disabled]="isSortedBy(null)" (click)="sortBy(null)">
      <mat-icon [style.visibility]="isSortedBy(null)?'visible':'hidden'">
        check
      </mat-icon>
      <span>{{text.sortNone}}</span>
    </button>

    @for(sort of sorts; track sort.id) {
    <button mat-menu-item (click)="sortBy(sort)">
      <mat-icon [style.visibility]="isSortedBy(sort)?'visible':'hidden'">
        {{sort.state == 'desc' ? 'arrow_downward' : 'arrow_upward'}}
      </mat-icon>
      <span>{{sort.title}}</span>
    </button>
    }

  </ng-template>

</mat-menu>

<mat-menu #groupings="matMenu">

  <ng-template matMenuContent let-groupings="groupings">

    <button mat-menu-item [disabled]="true">
      <span>{{text.groupTitle}}:</span>
    </button>

    <mat-divider></mat-divider>

    <button mat-menu-item [disabled]="isGroupedBy(null)" (click)="groupBy(null)">
      <mat-icon [style.visibility]="isGroupedBy(null)?'visible':'hidden'">
        check
      </mat-icon>
      <span>{{text.groupNone}}</span>
    </button>

    @for(grouping of groupings; track grouping.id) {
    <button mat-menu-item [disabled]="isGroupedBy(grouping)" (click)="groupBy(grouping)">
      <mat-icon [style.visibility]="isGroupedBy(grouping)?'visible':'hidden'">
        check
      </mat-icon>
      <span>{{grouping.title}}</span>
    </button>
    }

  </ng-template>

</mat-menu>